import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link ,NavLink,useParams,useNavigate} from "react-router-dom"
import { render } from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    is_phone_hk,
    convert_to_english_strhk,
    scrollTo_uphk,
    show_menu_hh,
    Modal_Select_agent_bk_show,
    Modal_Select_agent_all_hide,
    Agent_set_by_user,
    modal_select_agent_show_hide,
    Agent_by_user_get_appbk, Agent_set_address_get_data,
} from '../../clientconfigwebapp';
import { ToastContainer, toast } from 'react-toastify';


import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";
import logo_main from "../../assets/images/logo-web-app.svg";
import caffe_animation from "../../assets/images/icons/caffe-animation.gif";
import {Skeleton} from "@mui/material";
import LazyLoad from "react-lazy-load";
import {MiniSearch} from "../../assets/icones/icones";
import LocationOnIcon from '@mui/icons-material/LocationOn';


const serialize = require('form-serialize');


const Modal_Select_agent = () => {

    const redirect_navigate = useNavigate();

    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    const [data_list_agent_seach_box, set_data_list_agent_seach_box] = useState([]);
    const [data_defult_list_agent, set_data_defult_list_agent] = useState([]);
    const[title_text_serarch_agent,set_title_text_serarch_agent] = useState('');


    useEffect(() => {
        Handler_serarch_box();

        var id_get_agent=Agent_by_user_get_appbk("id_agent");

        if(!empty_bk(id_get_agent)){  modal_select_agent_show_hide("hide");  }else{ modal_select_agent_show_hide("show");  }



       /// scrollTo_uphk();
       /// localStorage.removeItem("tokenacess");
    }, [1]);






    const  Handle_modal_select_agent_close = () =>{
        var id_get_agent=Agent_by_user_get_appbk("id_agent");

        if(!empty_bk(id_get_agent)){  modal_select_agent_show_hide("hide");  }else{
            toast.error("شعبه را انتخاب کنید", {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        }
    }


    const Handler_agent_select=(id_agent,name_agent,address="",phone_agent_get="")=>{
       Agent_set_by_user(id_agent,name_agent);

        Agent_set_address_get_data(address,phone_agent_get);

        window.location.reload();


    }

    const Handler_custom_serarch_box=(event)=>{
        if(!empty_bk(event.target.value)){
            set_title_text_serarch_agent(convert_to_english_strhk(event.target.value));
            Handler_serarch_box();
        }else{
            set_title_text_serarch_agent("");
            Handler_serarch_box();
        }

    }


    // useEffect(() => {
    //     Handler_serarch_box();
    //     console.log("aaaaaa","vvvvv");
    // }, [title_text_serarch_agent])

    const Handler_serarch_box = () => {


       // if(empty_bk(title_text_serarch_agent)==false) {
        if(1==1) {

            const data_form_add = {title_search:String(title_text_serarch_agent)}; //filter_search:String(filter_search)

            console.log(data_form_add,"eeeeeeeee")

            if (data_form_add != null) {


                axios.post(`${clientconfigwebapp.siteurl}api/v1/search-agents`,data_form_add)
                    .then((res) => {
                        ///Setloadinghkfullshow_search("false");

                        console.log(res.data, "777777777");


                        if(String(res.data.data_list_agent).length > 0) {

                            // /console.log(res.data.data, "is 657567");
                            if (res.data.status=="success"){

                                if(String(res.data.data_list_agent).length > 0) {  set_data_list_agent_seach_box(res.data.data_list_agent); }


                            }else {
                                toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                            }


                        }else{
                            /////  Setloadinghkfullshow_search("false");
                            if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                        }

                        ///localStorage.setItem('token',response.data.Auth.access_token)
                    }).catch((err) =>{

                    ///// console.log("rrrr", "777777777");

                    //// Setloadinghkfullshow_search("false");
                    toast.error('خطای اتصال به سرور اینترنت خود را چک کنید.', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    ///// console.error(err, "is error 4535!");

                });


                /// Setloadinghkfullshow_search("false");
            }else{
                ///// Setloadinghkfullshow_search("false");
                alert('errcode:345765');
            }

        }else{
          ////  set_data_list_agent_seach_box([]);
        }

    }

    return (
        <Fragment>
            <div className="modal_select_agent modal_animation_bk_2" id={"modal_select_agent"} style={{"display":"block"}}>
                <div className={"modal-bg-bk"}  onClick={ Handle_modal_select_agent_close }   ></div>

                <div className="modal_page_main_select_agent">

                    <ToastContainer/>
                    <section className="flexColStartCenter modal_select_agent-container">



                        <span className={"close-btn-modal-reglogin"} onClick={Handle_modal_select_agent_close} style={{color: "black", position: "absolute", left: 49, top: 35, fontSize: 23}}>X</span>


                        <form id="form_select_agent" style={{"width":"100%"}} onsubmit="return false;">

                            <section style={{"display":"flex","flexDirection":"column","justifyContent":"center","alignItems":"center","alignContent":"center","flexWrap":"nowrap","width":"100%"}} >

                              <div  style={{"textAlign":"center"}}>  <img src={logo_main}   /></div>



                                <div className={"title-box-agent-page"} style={{"display":"flex","flexFlow":"row","placeContent":"center","alignItems":"center","paddingTop":"10px"}}>
                                    <div >  <img style={{"width":"42px","position":"relative","top":"-10px"}} src={caffe_animation}   /></div>
                                    <span style={{"display":"block","textAlign":"center","paddingTop":"8px","paddingBottom":"20px","color":"black","fontWeight":"bold"}}>شعبه مورد نظر خود را انتخاب کنید</span>
                                </div>















                                <section className='w-100' style={{"paddingTop":"18px"}}>


                                    <div
                                        style={{
                                            display: "flex",
                                            alignContent: "center",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            flexWrap: "nowrap",
                                            flexDirection: "row-reverse"
                                        }}


                                    >
                                        <label className="" style={{ position: "relative", left: 27 }}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="1rem"
                                                height="1rem"
                                                viewBox="0 0 14 14"
                                                fill="none"
                                            >
                                                <path
                                                    d="M14 13.2678L10.0893 9.35711C11.0291 8.22892 11.4977 6.78185 11.3977 5.31693C11.2977 3.85202 10.6368 2.48205 9.55246 1.49202C8.46811 0.501988 7.04382 -0.0318806 5.57588 0.00147384C4.10793 0.0348283 2.70936 0.632837 1.6711 1.6711C0.632837 2.70936 0.0348283 4.10793 0.00147384 5.57588C-0.0318806 7.04382 0.501988 8.46811 1.49202 9.55246C2.48205 10.6368 3.85202 11.2977 5.31693 11.3977C6.78185 11.4977 8.22892 11.0291 9.35711 10.0893L13.2678 14L14 13.2678ZM1.05418 5.71468C1.05418 4.79292 1.32752 3.89186 1.83962 3.12545C2.35172 2.35903 3.07959 1.76168 3.93118 1.40894C4.78278 1.0562 5.71985 0.963907 6.62389 1.14373C7.52794 1.32356 8.35836 1.76743 9.01014 2.41921C9.66193 3.07099 10.1058 3.90141 10.2856 4.80546C10.4654 5.70951 10.3732 6.64658 10.0204 7.49817C9.66767 8.34976 9.07032 9.07763 8.30391 9.58974C7.53749 10.1018 6.63644 10.3752 5.71468 10.3752C4.47906 10.3738 3.29444 9.88235 2.42072 9.00863C1.54701 8.13492 1.05555 6.9503 1.05418 5.71468Z"
                                                    fill="black"
                                                />
                                            </svg>
                                        </label>
                                        <input
                                            autoComplete="off"
                                            type="text"
                                            id="title_text_serarch_agent"
                                            name="title_text_serarch_agent"
                                            className="input-modal_select_agent"
                                            placeholder="جستجو..."
                                            onChange={Handler_custom_serarch_box}

                                        />
                                    </div>


                                    {  data_list_agent_seach_box.length > 0 ?  (
                                        <div className={"box-item-full-agent"}>

                                            <ul className={"items_agents_list"}>
                                                {data_list_agent_seach_box.map((item, index) => {
                                                    return (
                                    <li  onClick={() => Handler_agent_select(String(item.id_post),String(item.title_post),String(item.address_agent),String(item.phone_number_agent)) }  key={index}>
                                    <div className={"item_agent"} >
                                       <LocationOnIcon style={{"fontSize":"20px"}}/>
                                    <span>{item.title_post}</span>
                                    </div>
                                    </li>
                                                    )
                                                })}
                                            </ul>

                                        </div>

                                    ) : (<Fragment></Fragment>)

                                    }








                                </section>








                            </section>


                        </form>




                    </section>

                </div>
            </div>

        </Fragment>
    );
}


export default Modal_Select_agent;